module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "cashierdetail"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    staticClass: "first",
    attrs: {
      "to": {
        path: '/main/cashiermanage'
      },
      "replace": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L1')))]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.$t('cashMng.crumbs.L2')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group panel-select-group__justify"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.detail.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "info_wrapper",
    class: {
      'wrapper': _vm.lang === 'ja' || _vm.lang === 'en'
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.status')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#FF8100",
      "off-color": "#d8d8d8",
      "on-value": "1",
      "off-value": "0"
    },
    on: {
      "change": _vm.changeStatus
    },
    model: {
      value: (_vm.opinfo.status),
      callback: function($$v) {
        _vm.$set(_vm.opinfo, "status", $$v)
      },
      expression: "opinfo.status"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.name')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.mobile')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.shop')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.user')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.number')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v(_vm._s(_vm.opinfo.opuid))])]), _vm._v(" "), _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.password')))]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_vm._v("******")])]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v(_vm._s(_vm.$t('cashMng.common.tip1')))])]), _vm._v(" "), (!_vm.role.haiwai) ? _c('div', {
    staticClass: "info next-bottom"
  }, [_c('div', {
    staticClass: "info__title"
  }, [_vm._v("退款权限")]), _vm._v(" "), _c('div', {
    staticClass: "info__desc"
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": "",
      "on-color": "#7ed321",
      "off-color": "#d8d8d8",
      "on-value": "1",
      "off-value": "0"
    },
    on: {
      "change": _vm.changeRights
    },
    model: {
      value: (_vm.opinfo.refund),
      callback: function($$v) {
        _vm.$set(_vm.opinfo, "refund", $$v)
      },
      expression: "opinfo.refund"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!_vm.role.haiwai) ? _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "info__title"
  }), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 目前收银员仅支持查看活动信息，不支持对红包、集点、储值活动、特卖、店铺公告、会员特权的增删改")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-btn-group__wrapper"
  }, [(!_vm.role.haiwai) ? _c('a', {
    attrs: {
      "href": _vm.downHref,
      "download": ""
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_record",
    on: {
      "click": _vm.changeInfo
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('cashMng.detail.btn')))])])])])])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('cashMng.detail.btn'),
      "visible": _vm.showChangeInfo,
      "custom-class": (_vm.lang === 'ja' || _vm.lang === 'en') ? 'mydialog haiwiadialog' : 'mydialog',
      "top": "20%",
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.showChangeInfo = $event
      },
      "close": _vm.handleClose
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.formrules,
      "label-width": (_vm.lang === 'ja' || _vm.lang === 'en') ? '135px' : '90px'
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.name'),
      "prop": "opname"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": _vm.$t('cashMng.common.m5')
    },
    model: {
      value: (_vm.form.opname),
      callback: function($$v) {
        _vm.$set(_vm.form, "opname", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.opname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.mobile'),
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "text",
      "placeholder": _vm.$t('cashMng.common.m6')
    },
    model: {
      value: (_vm.form.mobile),
      callback: function($$v) {
        _vm.$set(_vm.form, "mobile", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.shop')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.shop.shopname))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.user')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.shop.mobile))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.number')
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.opuid))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('cashMng.common.password'),
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "auto-complete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('cashMng.common.m7'),
      "id": "end-length"
    },
    on: {
      "change": _vm.passChange,
      "blur": _vm.passBlur,
      "focus": _vm.passFocus
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "cancel",
    on: {
      "click": function($event) {
        _vm.showChangeInfo = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('common.close')))]), _vm._v(" "), _c('div', {
    staticClass: "submit",
    on: {
      "click": _vm.submit
    }
  }, [(_vm.iconShow) ? _c('span', {
    staticClass: "el-icon-loading"
  }) : _c('span', [_vm._v(_vm._s(_vm.$t('common.confirm')))])])])], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail"
  }, [_c('i', {
    staticClass: "icon-download"
  }), _vm._v(" "), _c('span', [_vm._v("下载收款码")])])
}]}


//////////////////
// WEBPACK FOOTER
// /home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-455db992"}!/home/qfpay/fe_node_modules/v7.10.1/fe_chain_store_admin_hk/~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/cashierdetail/cashierdetail.vue
// module id = 914
// module chunks = 0